import CreateAudienceDropdown from '../../components/CreateAudienceDropdown';
import ErrorIcon from '../../components/ErrorIcon';
import ExportFailureLogPopup from '../../components/ExportFailureLogPopup';
import Field from 'components/Field';
import React, { useEffect, useMemo, useState } from 'react';
import _debounce from 'lodash/debounce';
import nanoid from 'utils/nanoid';
import {
  Audience,
  ToggleGroupNameDialogAction,
  addAudience,
  fetchEmails,
  fetchGroups,
  loadOriginalAudience,
  searchAudiences,
  setGroupDeletingState,
  setGroupSavingState,
  setUIState,
  toggleGroupNameDialog,
  updateCurrentAudience,
  updateCurrentGroup,
} from './slice';
import { Button, IconButton } from '@attain-sre/attain-design-system';
import { Formik } from 'formik';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import * as Styled from './index.styles';
import * as EditorAudienceStyled from './editor/index.styles';
// Material UI Components
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import GroupIcon from '@material-ui/icons/Group';
import HistoryIcon from '@mui/icons-material/History';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@material-ui/core/Typography';
import { CaretDown, MagnifyingGlass, Plus, Users } from '@phosphor-icons/react';
import {
  Theme,
  ThemeProvider,
  createStyles,
  createTheme,
  makeStyles,
} from '@material-ui/core/styles';

// Page Components
import AudienceStatusHeader from './audienceStatus';
import BootstrapTooltip from 'components/bootstrapTooltip';
import CircleIcon from '@mui/icons-material/Circle';
import CopyPopover from 'components/CopyPopover';
import DataTable from 'components/DataTable/DataTable';
import ExportHistroryDialog from './exportHistoryDialog';
import GhostLoader from 'react-ghost-loader';
import GroupDeleteDialog from './groupDeleteDialog';
import GroupName from './groupName';
import GroupNameDialog from './groupNameDialog';
import Header from 'components/Header';
import Link from 'components/Link';
import MultiSelect from 'components/MultiSelect';
import TextFieldSearch from 'components/TextFieldSearch/TextFieldSearch';
import moment from 'moment';
import tokens from 'tokens';
import useAudienceExportHistory from '../../graphql/hooks/useAudienceExportHistory';
import {
  AUDIENCE_EST_SIZE_TOOLTIP_HEADER,
  AUDIENCE_EXPORT_TYPES,
  AUDIENCE_LAL_MODAL_TYPE,
  AUDIENCE_SELECT_EMAIL_AUTO_COMPLETE,
  AUDIENCE_TYPE_LABLES,
  AudienceEstSizeLabel,
  AudienceSizeHistoryLabel,
  ENUM_SYSTEM_USED,
  ENUM_SYSTEM_USED_LABLE,
  PLATFORMS_KEYS,
  PLATFORMS_LABLES,
  Routes,
} from '../../constants';
import {
  AUDIENCE_MANAGER_COLUMN_TITLES,
  AUDIENCE_MANAGER_FILTER_LABLES,
  AUDIENCE_STUDIO,
  CREATE_AUDIENCE,
  CREATE_AUDIENCE_BY_CLICKING,
  CREATE_GROUP,
  ERROR_FETCHING_AUDIENCE,
  ERROR_PAGE_NOT_EXIST,
  GETTING_AUDIENCE_BY_UPATING_FILTERS,
  GROUP_DONE_NOT_HAVE_AUDIENCE,
  GROUP_DONE_NOT_HAVE_AUDIENCE_WITH_FILTERS,
  SELECT_GROUP,
} from '../../content';
import {
  ENUM_AUDIENCE_EXPORT_STATUS,
  getAudienceAndPlatformTypeStatus,
} from './exportHistoryDialog/exportHistoryUtils';
import { Popover } from '@mui/material';
import { RowingOutlined } from '@mui/icons-material';
import { getAudienceExportStatus } from 'utils/audienceExportStatus';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    createGroup: {
      backgroundColor: tokens.colorButtonLight,
      bottom: 0,
      height: 68,
      padding: 16,
      position: 'fixed',
      width: 248,
    },
    divider: {
      height: 2,
    },
    groupList: {
      marginBottom: 'auto',
      maxHeight: '500px',
      minHeight: '400px',
      overflow: 'scroll',
    },
    header: {
      display: 'flex',
      height: '80px',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      width: '100%',
    },
    noAudiences: {
      minHeight: '100%',
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
      height: '80vh',
    },
    searchAudience: {
      margin: 16,
    },
    searchGroup: {
      margin: 8,
      marginTop: 16,
    },
    verticalDivider: {
      borderRight: '2px solid rgb(232 232 232)',
    },
    audienceName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-block',
      cursor: 'pointer',
    },
    audienceStatusCol: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: 50,
      display: 'inline-block',
      fontSize: 16,
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    createdBy: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: 200,
      display: 'inline-block',
      fontSize: 16,
    },
    audienceStatus: {
      display: 'flex',
      gap: '5px',
      alignItems: 'center',
      top: '1px',
      position: 'relative',
    },
    tableCellText: {
      fontSize: '14px',
    },
    createAudienceButton: {
      fontSize: '16px !important',
    },
    audienceType: {
      fontSize: 16,
      color: '#000000d9',
      lineHeight: '20px',
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    platformType: {
      fontSize: 14,
      color: '#0000008c',
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    audienceSizeStatus: {
      fontSize: 14,
      color: '#0000008c',
      lineHeight: '20px',
      fontWeight: 500,
    },
    audienceSizeIcon: {
      color: 'gray',
      padding: '2px',
      marginTop: '-1px',
    },
    totalSize: {
      fontWeight: 500,
      lineHeight: '20px',
    },
    infoIcon: {
      color: 'gray',
      padding: '2px',
      marginTop: '1px',
      cursor: 'pointer',
    },
    tooltipContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '5px 15px 0px',
      border: '1px solid black',
      backgroundColor: 'white',
      borderRadius: '5px',
      color: 'black',
    },
    tooltipHeader: {
      fontWeight: 'bold',
      fontSize: '16px',
      paddingBottom: '5px',
      lineHeight: '18px',
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    tooltipItemHeader: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    tooltipItemText: {
      color: 'gray',
      fontSize: '14px',
      lineHeight: '16px',
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    popover: {
      '& > div': {
        boxShadow: 'none !important',
      },
    },
    popoverFooter: {
      fontSize: '12px',
      fontStyle: 'italic',
      color: 'gray',
      fontFamily: 'Calibre-Regular, sans-serif',
      textAlign: 'end',
    },
    noAudience: {
      fontSize: 20,
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    noAudienceSubText: {
      fontSize: 16,
      fontFamily: 'Calibre-Regular, sans-serif',
    },
    typeText: {
      border: '1px dashed gray',
      borderRadius: '100px',
      padding: '1px 4px',
      fontWeight: 600,
      fontSize: 16,
    },
  })
);

const inputs = createTheme({
  overrides: {
    MuiFormControl: {
      root: {
        maxHeight: 48,
      },
    },
    MuiFormLabel: {
      root: {
        maxHeight: 48,
      },
    },
    MuiInputLabel: {
      root: {
        marginTop: -5,
        '&$focused': {
          marginTop: 0,
        },
      },
    },
    MuiInputBase: {
      root: {
        maxHeight: 48,
      },
      input: {
        borderRadius: 10,
        alignSelf: 'center',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 10,
      },
      input: {
        padding: '12px 14px',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 10,
      },
      outlinedPrimary: {
        color: tokens.colorButtonPrimary,
      },
      containedPrimary: {
        backgroundColor: tokens.colorButtonPrimary,
        '&:hover': {
          backgroundColor: tokens.colorButtonPrimary,
        },
      },
    },
    MuiButtonBase: {
      root: {
        borderRadius: 10,
      },
    },
    MuiPopover: {
      overrides: {
        Paper: {
          boxShadow: 'none',
        },
      },
    },
  },
});

const audienceTypeOptions = [
  {
    id: ENUM_SYSTEM_USED.STANDARD_AUDIENCE,
    label: AUDIENCE_TYPE_LABLES.DESIGNER,
  },
  {
    id: ENUM_SYSTEM_USED.COMBINED_AUDIENCE,
    label: AUDIENCE_TYPE_LABLES.BLENDER,
  },
  {
    id: ENUM_SYSTEM_USED.CUSTOM_AUDIENCE,
    label: AUDIENCE_TYPE_LABLES.FILE,
  },
];

const platformOptions = [
  {
    id: PLATFORMS_KEYS.NOT_EXPORTED,
    label: PLATFORMS_LABLES.NOT_EXPORTED,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.EXPERIAN_KEY,
    label: PLATFORMS_LABLES.EXPERIAN,
    hide: true,
  },
  {
    id: PLATFORMS_KEYS.KLOVER_IDS_KEY,
    label: PLATFORMS_LABLES.KLOVER_IDS,
    hide: true,
  },
  {
    id: PLATFORMS_KEYS.LIVERAMP_KEY,
    label: PLATFORMS_LABLES.LIVERAMP,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.MAGNITE_KEY,
    label: PLATFORMS_LABLES.MAGNITE,
    hide: true,
  },
  {
    id: PLATFORMS_KEYS.META_KEY,
    label: PLATFORMS_LABLES.META,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.OPENX_KEY,
    label: PLATFORMS_LABLES.OPENX,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.WPP_KEY,
    label: PLATFORMS_LABLES.WPP,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.DENTSU_KEY,
    label: PLATFORMS_LABLES.DENTSU,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.PUBMATIC_KEY,
    label: PLATFORMS_LABLES.PUBMATIC,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.TRANSUNION_KEY,
    label: PLATFORMS_LABLES.TRANSUNION,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.TTD_KEY,
    label: PLATFORMS_LABLES.TTD,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.X_KEY,
    label: PLATFORMS_LABLES.X,
    hide: true,
  },

  {
    id: PLATFORMS_KEYS.YAHOO_DSP_KEY,
    label: PLATFORMS_LABLES.YAHOO_DSP,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.TIKTOK_KEY,
    label: PLATFORMS_LABLES.TIKTOK,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.REDDIT_KEY,
    label: PLATFORMS_LABLES.REDDIT,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.AMAZON_KEY,
    label: PLATFORMS_LABLES.AMAZON,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.APPSFLYER_KEY,
    label: PLATFORMS_LABLES.APPSFLYER,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.NEXXEN_KEY,
    label: PLATFORMS_LABLES.NEXXEN,
    hide: false,
  },
  {
    id: PLATFORMS_KEYS.VIANT_KEY,
    label: PLATFORMS_LABLES.VIANT,
    hide: false,
  },
];

const AudienceManager = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [allGroups, setAllGroups] = useState(false);
  const [audienceTypeSelected, setAudienceTypeSelected] = useState([]);
  const [platformSelected, setPlatformSelected] = useState([]);

  const [oprations, setOprations] = useState({
    page: 0,
    rowsPerPage: 25,
    sortBy: 'updatedAt',
    sortOrder: 'DESC',
    search: '',
    email: searchParams.get('email') || 'all',
    groupId: searchParams.get('groupId') || 'all',
  });
  const { groupId } = oprations;

  useEffect(() => {
    dispatch(fetchEmails());
    dispatch(fetchGroups());
  }, []);

  const debouncedSearch = _debounce(searchParams => {
    dispatch(
      searchAudiences({
        ...searchParams,
        audienceType: audienceTypeSelected,
        platformType: platformSelected,
      })
    );
  }, 500);

  useEffect(() => {
    debouncedSearch(oprations);
    return () => {
      debouncedSearch.cancel();
    };
  }, [
    oprations.page,
    oprations.rowsPerPage,
    oprations.sortBy,
    oprations.sortOrder,
    oprations.groupId,
    oprations.search,
    oprations.email,
    audienceTypeSelected,
    platformSelected,
  ]);

  useEffect(() => {
    if (openGroupNameDialog) return;
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('groupId');
    const currGroup = audienceReducer.entities.groups.byId[id];
    if (currGroup) {
      dispatch(updateCurrentGroup(currGroup));
    } else {
      setAllGroups(true);
    }
  }, [openGroupNameDialog]);

  useEffect(() => {
    if (groupId && groupId !== 'all') {
      const currentGroup = audienceReducer.entities.groups.byId[groupId];
      if (currentGroup) {
        dispatch(updateCurrentGroup(currentGroup));
        setAllGroups(false);
      }
    } else {
      setAllGroups(true);
      dispatch(updateCurrentGroup(null));
    }

    window.history.replaceState(
      null,
      '',
      `${location.pathname}?groupId=${groupId}&email=${oprations.email}`
    );
  }, [groupId]);

  const audienceReducer = useAppSelector(state => {
    return state.audienceReducer;
  });

  const currentGroup = useAppSelector(
    state => state.audienceReducer.currentGroup
  );
  const openGroupDeleteDialog = useAppSelector(
    state => state.audienceReducer.ui.openGroupDeleteDialog
  );
  const openGroupNameDialog = useAppSelector(
    state => state.audienceReducer.ui.openGroupNameDialog
  );

  const audiences = useAppSelector(state => {
    return state.audienceReducer.entities.audiences.allIds.map(id => {
      return state.audienceReducer.entities.audiences.byId[id];
    });
  });

  const groups = useAppSelector(state => {
    return state.audienceReducer.entities.groups.allIds
      .map(id => state.audienceReducer.entities.groups.byId[id])
      .filter(group => {
        if (name !== '') {
          return group.name.toLowerCase().includes(name);
        } else {
          return true;
        }
      });
  });

  const emails = useAppSelector(
    state => state.audienceReducer.entities?.emails
  );

  const groupLoading = useAppSelector(
    state => state.audienceReducer.ui.groupLoading
  );

  const errorFetching = useAppSelector(
    state => state.audienceReducer.ui.errorFetching
  );

  const groupsLoading = useAppSelector(
    state => state.audienceReducer.ui.groupsLoading
  );

  const isEmailLoading = useAppSelector(
    state => state.audienceReducer.ui.emailIsLoading.state === 'loading'
  );

  const addAudienceHandler = option => {
    dispatch(loadOriginalAudience(null));
    dispatch(setGroupDeletingState({ state: 'idle' }));
    dispatch(setGroupSavingState({ state: 'idle' }));
    dispatch(
      addAudience({
        ...newAudience,
        groupId: groupId,
        lalModelType: option,
      })
    );
  };

  const handleCreateGroup = () => {
    const actionProps: ToggleGroupNameDialogAction = {
      open: true,
    };
    dispatch(toggleGroupNameDialog(actionProps));
  };

  const handleShowGroup = (id) => {
    setOprations({ ...oprations, groupId: id, page: 0 });
    setAllGroups(id ? false : true);
  };

  const isAudiencesLoading = groupLoading.state === 'loading';
  const isGroupsLoading = groupsLoading.state === 'loading';

  const newAudience: Audience = {
    id: nanoid(),
    name: '',
    totalSize: 0,
    dimensions: [],
    dimensionGroups: [],
    createdAt: 0,
    updatedAt: 0,
    groupId: '',
  };

  const groupsOptions = useMemo(() => {
    const data = [
      { label: 'All Groups', id: 'all' },
      ...groups
        ?.sort((a, b) => b.updated_at - a.updated_at)
        ?.map(a => {
          return { label: a.name, id: `${a.id}` };
        }),
    ];
    return data;
  }, [groups]);

  const handleChangePage = (newPage: number) => {
    setOprations({
      ...oprations,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (value: number) => {
    const newPageSize = parseInt(value, 10);
    setOprations({
      ...oprations,
      page: 0,
      rowsPerPage: newPageSize,
    });
  };

  const handleOnSortChange = sortInfo => {
    let sortOrder = 'DESC';
    if (oprations.sortBy === sortInfo.column) {
      sortOrder = oprations.sortOrder == 'ASC' ? 'DESC' : 'ASC';
    }

    setOprations({
      ...oprations,
      sortBy: sortInfo.column,
      sortOrder: sortOrder,
    });
  };

  const handleMenuItemClick = (option: string) => {
    addAudienceHandler(option);
    history.push(Routes.AUDIENCE_STUDIO_AUDIENCE_SELECTOR);
  };

  const isOnlyGroupSelected =
    !oprations.search &&
    oprations.groupId !== 'all' &&
    oprations.email == 'all' &&
    audienceTypeSelected.length === 0 &&
    platformSelected.length === 0;

  return (
    <>
      <Box className={classes.root}>
        <Header
          title={AUDIENCE_STUDIO}
          centerBorder={true}
          center={!allGroups ? currentGroup && <GroupName /> : null}
          action={
            <>
              {currentGroup && !allGroups ? (
                <CreateAudienceDropdown
                  handleMenuItemClick={handleMenuItemClick}
                  audienceType={ENUM_SYSTEM_USED.STANDARD_AUDIENCE}
                />
              ) : null}
            </>
          }
        />

        <Box height='100%'>
          <Styled.SearchArea>
            <>
              <ThemeProvider theme={inputs}>
                <Button
                  variant='contained'
                  onClick={handleCreateGroup}
                  startIcon={<Plus />}
                  style={{ fontSize: '16px' }}
                >
                  {CREATE_GROUP}
                </Button>
              </ThemeProvider>

              <Formik>
                {() => (
                  <Styled.Form onSubmit={e => e.preventDefault()}>
                    <Field
                      name='searchAudiences'
                      placeholder='Search Audiences'
                      value={oprations.search}
                      style={{ height: 44, width: 380 }}
                      onChange={e => {
                        setOprations({
                          ...oprations,
                          search: e.target.value,
                          page: 0,
                        });
                      }}
                    />
                  </Styled.Form>
                )}
              </Formik>
            </>

            <Styled.SelectAutoCompleteGroup
              disablePortal
              id='select-audience-group'
              options={groupsOptions}
              disabled={isGroupsLoading}
              popupIcon={<CaretDown />}
              value={
                groupsOptions.find(a => `${a?.id}` === `${groupId}`)?.label
              }
              renderInput={params => (
                <TextFieldSearch
                  {...params}
                  placeholder={SELECT_GROUP}
                  variant='outlined'
                />
              )}
              onChange={(e, newValue) => {
                if (newValue?.id) {
                  setOprations({
                    ...oprations,
                    page: 0,
                    groupId: newValue?.id?.toString(),
                  });
                  setAllGroups(newValue?.id ? false : true);
                }
              }}
              renderOption={(props, option) => (
                <Styled.SelectAutoCompleteGroupOptions>
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                </Styled.SelectAutoCompleteGroupOptions>
              )}
            />
            <Styled.SelectAutoCompleteEmail
              disablePortal
              id='select-audience-email'
              options={emails}
              disabled={isEmailLoading}
              popupIcon={<CaretDown />}
              value={emails?.find(a => a?.id === `${oprations.email}`)?.label}
              renderInput={params => (
                <TextFieldSearch
                  {...params}
                  placeholder={AUDIENCE_SELECT_EMAIL_AUTO_COMPLETE}
                  variant='outlined'
                />
              )}
              onChange={(e, newValue: any) => {
                if (newValue?.id) {
                  setOprations({
                    ...oprations,
                    page: 0,
                    email: newValue?.id,
                  });
                  if (newValue?.id !== oprations.email) {
                    window.history.replaceState(
                      null,
                      '',
                      groupId
                        ? `${location.pathname}?groupId=${groupId}&email=${newValue?.id}`
                        : `${location.pathname}?email=${newValue?.id}`
                    );
                  }
                }
              }}
              renderOption={(props, option) => (
                <Styled.SelectAutoCompleteGroupOptions>
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                </Styled.SelectAutoCompleteGroupOptions>
              )}
            />
            <Styled.MultiSelectWrapper>
                  <MultiSelect
                    options={audienceTypeOptions}
                    value={audienceTypeSelected}
                    onChange={setAudienceTypeSelected}
                    placeholder={AUDIENCE_MANAGER_FILTER_LABLES.AUDIENCE_TYPE}
                    tagLimit={1}
                  />
                </Styled.MultiSelectWrapper>
                <Styled.MultiSelectWrapper>
                  <MultiSelect
                    options={platformOptions?.filter(x => !x.hide)}
                    value={platformSelected}
                    onChange={setPlatformSelected}
                    placeholder={AUDIENCE_MANAGER_FILTER_LABLES.PLATFORM}
                    tagLimit={1}
                  />
                </Styled.MultiSelectWrapper>
          </Styled.SearchArea>

          {!errorFetching && (
            <AudienceTable
              loading={isAudiencesLoading}
              audiences={audiences}
              selectedGroupId={groupId}
              groups={groups}
              handleShowGroup={handleShowGroup}
              oprations={oprations}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleOnSortChange={handleOnSortChange}
              isOnlyGroupSelected={isOnlyGroupSelected}
            />
          )}
          {errorFetching && (
            <EditorAudienceStyled.AudienceContainer>
              <EditorAudienceStyled.AudienceUnknown>
                <EditorAudienceStyled.AudienceUnknownText>
                  {ERROR_FETCHING_AUDIENCE}
                </EditorAudienceStyled.AudienceUnknownText>
              </EditorAudienceStyled.AudienceUnknown>
            </EditorAudienceStyled.AudienceContainer>
          )}
        </Box>
      </Box>

      <GroupDeleteDialog open={openGroupDeleteDialog} />
      <GroupNameDialog open={openGroupNameDialog} />
    </>
  );
};

interface Props {
  audiences: Audience[];
  groups: any;
  handleShowGroup: any;
  selectedGroupId: any;
  loading: boolean;
  oprations: {
    page: number;
    rowsPerPage: number;
    sortBy: string;
    sortOrder: string;
  };
  handleChangePage: () => {};
  handleChangeRowsPerPage: () => {};
  handleOnSortChange: () => {};
  audienceTypeSelected: any[];
}

/**
 * Est Audience size details popup which helps to check audience count with respective export stage
 */
export const AudienceEstSizePopup = ({ audience, exportHistory }) => {
  const classes = useStyles();
  let exportedCount = 'Pending',
    platformUsersCount = 'Pending',
    platformUsersCountActiveIds = 'Pending',
    uuid2Count = 'Pending',
    updatedAt = moment(
      new Date(Number(audience.updatedAt || audience.updatedat)) //updatedAt - Audience Manager | updatedat - Custom Audience
    ).format('MM/DD/YYYY HH:mm:ss');
  const audienceSize =
    audience?.totalSize?.toLocaleString() || //Audience Manager
    audience?.size?.toLocaleString() || //Custom Audience
    'Pending';
  let seedCount = audienceSize;
  let platformIntegrated = '';

  if (exportHistory) {
    const latestExport = exportHistory;
    platformIntegrated = latestExport?.platform_integrated;
    const seededCount = latestExport?.seeded_users_count?.toLocaleString() || latestExport?.seededUsersCount?.toLocaleString() || 'Pending';
    exportedCount =
      latestExport?.exported_users_count?.toLocaleString() || latestExport?.exportedUsersCount?.toLocaleString() || 'Pending';
    platformUsersCount =
      latestExport?.platform_users_count?.toLocaleString() || latestExport?.platformUsersCount?.toLocaleString() || 'Pending';
    platformUsersCountActiveIds =
      latestExport?.platform_users_count_active_ids?.toLocaleString() || latestExport?.platformUsersCountActiveIds?.toLocaleString() || 'Pending';
    uuid2Count = latestExport?.uid2_users_count?.toLocaleString() || latestExport?.uid2UsersCount?.toLocaleString() || 'Pending';
    seedCount = seededCount;
    const status = latestExport?.export_status || latestExport?.exportStatus;
    switch (status) {
      case ENUM_AUDIENCE_EXPORT_STATUS.SENT:
        {
          if (latestExport?.timestamp_status_export_started || latestExport?.timestampStatusExportStarted) {
            const time = latestExport?.timestamp_status_export_started || latestExport?.timestampStatusExportStarted;
            updatedAt = moment(time).format('MM/DD/YYYY HH:mm:ss');
          }
        }
        break;
      case ENUM_AUDIENCE_EXPORT_STATUS.LIVE_IN_TTD:
        {
          if (latestExport?.timestamp_platform_users || latestExport?.timestampPlatformUsers) {
            const time = latestExport?.timestamp_platform_users || latestExport?.timestampPlatformUsers;
            updatedAt = moment(time).format('MM/DD/YYYY HH:mm:ss');
          }
        }
        break;
      default:
        break;
    }
  }

  let data = [];
  if (platformIntegrated === 'trade_desk') {
    data = [
      {
        label: AudienceSizeHistoryLabel.SEED_AUDIENCE,
        value: seedCount,
      },
      {
        label: AudienceSizeHistoryLabel.EXPORTED_AUDIENCE,
        value: exportedCount,
      },
      {
        label: AudienceSizeHistoryLabel.UUID,
        value: uuid2Count,
      },
      {
        label: AudienceSizeHistoryLabel.TREAD_DESK,
        subItems: [
          {
            label: AudienceSizeHistoryLabel.RECEIVED_IDS,
            value: platformUsersCount,
          },
          {
            label: AudienceSizeHistoryLabel.ACTIVE_IDS,
            value: platformUsersCountActiveIds,
          },
        ],
      },
    ];
  } else {
    data = [
      {
        label: AudienceSizeHistoryLabel.SEED_AUDIENCE,
        value: seedCount,
      },
      {
        label: AudienceSizeHistoryLabel.EXPORTED_AUDIENCE,
        value: exportedCount,
      },
      {
        label: AudienceSizeHistoryLabel.TREAD_DESK,
        subItems: [
          {
            label: AudienceSizeHistoryLabel.RECEIVED_IDS,
            value: platformUsersCount,
          },
          {
            label: AudienceSizeHistoryLabel.ACTIVE_IDS,
            value: platformUsersCountActiveIds,
          },
        ],
      },
    ];
  }

  return (
    <div className={classes.tooltipContainer}>
      <div className={classes.tooltipHeader}>
        {AUDIENCE_EST_SIZE_TOOLTIP_HEADER}
      </div>
      <ul style={{ marginLeft: '-25px' }}>
        {data.map(x => {
          return (
            <li key={x.label}>
              <span className={classes.tooltipItemHeader}>{x.label}</span>
              {x.value ? ' - ' : ''}
              {x.value && (
                <span className={classes.tooltipItemText}>
                  <CopyPopover value={x.value} />
                </span>
              )}

              {x?.subItems &&
                x?.subItems?.length > 0 && ( // Check for sub-items
                  <ul style={{ marginLeft: '-15px' }}>
                    {x.subItems.map(subItem => (
                      <li key={subItem.label}>
                        <span className={classes.tooltipItemHeader}>
                          {subItem.label}
                        </span>
                        {' - '}
                        <span className={classes.tooltipItemText}>
                          <CopyPopover value={subItem.value} />
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
            </li>
          );
        })}
      </ul>
      <div className={classes.popoverFooter}>
        <span>Last Updated: {updatedAt} </span>
      </div>
    </div>
  );
};

/**
 * Helps to get estimated audience size and relative labels
 */
export const getAudienceEstSizeDetails = (
  audience: any,
  exportHistory: any
) => {
  let exportedCount = 'Pending',
    uuid2Count = 'Pending',
    platformUsersCountActiveIds = 'Pending';
  const audienceSize =
    audience?.totalSize?.toLocaleString() ||
    audience?.size?.toLocaleString() ||
    'Pending';

  if (exportHistory) {
    const latestExport = exportHistory;
    const platformIntegrated = latestExport?.platform_integrated;
    exportedCount =
      latestExport?.exported_users_count?.toLocaleString() || 'Pending';
    uuid2Count = latestExport?.uid2_users_count?.toLocaleString() || 'Pending';
    platformUsersCountActiveIds =
      latestExport?.platform_users_count_active_ids?.toLocaleString() || 'Pending';

    switch (latestExport.export_status) {
      case ENUM_AUDIENCE_EXPORT_STATUS.SENT:
      case ENUM_AUDIENCE_EXPORT_STATUS.LATE:
        return {
          audinceSize: exportedCount,
          audienceExportLabel: AudienceEstSizeLabel.EXPORTED_AUDIENCE,
        };
      case ENUM_AUDIENCE_EXPORT_STATUS.MODELING_COMPLETED:
        if (platformIntegrated === 'trade_desk') {
          return {
            audinceSize: uuid2Count ? uuid2Count : audienceSize,
            audienceExportLabel: uuid2Count
              ? AudienceEstSizeLabel.TTD_UUID2
              : AudienceEstSizeLabel.SEED_AUDIENCE,
          };
        } else {
          return {
            audinceSize: audienceSize,
            audienceExportLabel: AudienceEstSizeLabel.SEED_AUDIENCE,
          };
        }
      case ENUM_AUDIENCE_EXPORT_STATUS.LIVE_IN_TTD:
        return {
          audinceSize: platformUsersCountActiveIds,
          audienceExportLabel: AudienceEstSizeLabel.TTD_AUDIENCE,
        };
      default:
        return {
          audinceSize: audienceSize,
          audienceExportLabel: AudienceEstSizeLabel.SEED_AUDIENCE,
        };
    }
  }

  return {
    audinceSize: audienceSize,
    audienceExportLabel: AudienceEstSizeLabel.SEED_AUDIENCE,
  };
};

const AudienceTable = ({
  audiences,
  handleShowGroup,
  oprations,
  handleChangePage,
  handleChangeRowsPerPage,
  handleOnSortChange,
  loading = true,
  isOnlyGroupSelected = false,
}: Props) => {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const history = useHistory();

  const { sortBy, sortOrder } = oprations;
  const [openExportHistoryDialog, setOpenExportHistoryDialog] = useState(false);
  const [currentAudienceHistory, setCurrentAudienceHistory] = useState([]);
  const [currentAudience, setCurrentAudience] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  // STEP 1: Extract audience IDs for GraphQL query from the filtered data
  // This ensures we only fetch export history for audiences that are currently displayed
  const audienceIds = useMemo(() => {
    return audiences?.map(x => x.id) || [];
  }, [audiences]);

  // STEP 2: Fetch export history using GraphQL - only when we have audience IDs
  const {
    loading: exportHistoryLoading,
    exportHistory,
    error,
  } = useAudienceExportHistory({
    audienceIds,
  });

  // STEP 3: Create a map of audience ID to export history for quick lookup
  // This allows us to quickly find export history for each audience in the table
  const exportHistoryMap = useMemo(() => {
    const map = {};
    if (exportHistory && exportHistory.length > 0) {
      exportHistory.forEach(history => {
        if (!map[history.audience_id]) {
          map[history.audience_id] = [];
        }
        map[history.audience_id].push(history);
      });
    }
    return map;
  }, [exportHistory]);

  const states = useAppSelector(state => {
    return state.audienceReducer.ui.states;
  });

  const handleShowAudience = (audience: Audience) => {
    dispatch(updateCurrentAudience(audience));
    dispatch(setGroupDeletingState({ state: 'idle' }));
    dispatch(setGroupSavingState({ state: 'idle' }));
  };

  const data = useMemo(
    () => audiences && audiences.filter(x => x),
    [audiences]
  );

  const count =
    data.length > 0
      ? typeof data[0].totalcount === 'string'
        ? Number(data[0].totalcount)
        : data[0].totalcount
      : 1;

  const columns = [
    {
      title: AUDIENCE_MANAGER_COLUMN_TITLES.GROUP,
      column: 'groupId',
      isSorted: sortBy === 'groupId',
      sortOrder: sortOrder,
    },
    {
      title: AUDIENCE_MANAGER_COLUMN_TITLES.NAME,
      column: 'name',
      isSorted: sortBy === 'name',
      sortOrder: sortOrder,
      width: '550px',
    },
    {
      title: AUDIENCE_MANAGER_COLUMN_TITLES.TYPE,
      column: 'type',
      isSorted: sortBy === 'type',
      sortOrder: sortOrder,
    },
    {
      title: AUDIENCE_MANAGER_COLUMN_TITLES.PLATFORM,
      column: 'platform',
      width: '12%',
      isSortDisabled: true,
    },
    {
      title: <AudienceStatusHeader />,
      column: 'exportStatus',
      width: '15%',
      isSortDisabled: true,
    },
    {
      title: AUDIENCE_MANAGER_COLUMN_TITLES.ESTIMATED_SIZE,
      column: 'totalSize',
      isSorted: sortBy === 'totalSize',
      sortOrder: sortOrder,
      width: '10%',
    },
    {
      title: AUDIENCE_MANAGER_COLUMN_TITLES.LAST_MODIFIED,
      column: 'updatedAt',
      isSorted: sortBy === 'updatedAt',
      sortOrder: sortOrder,
      width: '9%',
    },
  ];

  const formattedRows = data?.map(x => {
    // STEP 4: Bind export history to each audience
    // Get export history from GraphQL data instead of audience.exportHistory
    const audienceExportHistory = exportHistoryMap[x.id] || x?.exportHistory || [];
    const latestExportHistory =
      audienceExportHistory.length > 0 ? audienceExportHistory[0] : null;

    const { audinceSize, audienceExportLabel } = getAudienceEstSizeDetails(
      x,
      latestExportHistory
    );
    const isInHouseExport =
      latestExportHistory?.lal_model_type === AUDIENCE_LAL_MODAL_TYPE.ATTAIN;
    const inHouseModelingStatus = x.inHouseModelingStatus;
    const platformIds = getPlatformTypes(x?.platforms || []);
    const type = ENUM_SYSTEM_USED_LABLE[x.type];

    return (
      <>
        <td>
          <Link
            to={`${Routes.AUDIENCE_STUDIO}?groupId=${x.groupId}&email=all`}
            onClick={() => handleShowGroup(x.groupId)}
            disabled={
              states &&
              RowingOutlined &&
              RowingOutlined.id &&
              states[RowingOutlined.id]
                ? true
                : false
            }
          >
            {x.groupName}
          </Link>
        </td>
        <td>
          <Styled.AudienceName>
            <Link
              to={`${Routes.AUDIENCE_STUDIO_EDITOR}/${x.id}`}
              toParams={{
                audienceType: x.type,
              }}
            >
              {x?.name || null}
            </Link>
          </Styled.AudienceName>
        </td>
        <td>
          <Styled.Type>{type}</Styled.Type>
        </td>
        <td>
          <Styled.Plaform>
            {exportHistoryLoading ? (
              <GhostLoader height="20px" width="80px" />
            ) : (
              <AudienceTypeLabelDisplay platformIds={platformIds} />
            )}
          </Styled.Plaform>
        </td>
        <td>
          <Styled.AudienceStatus className={classes.audienceStatusCol}>
            {exportHistoryLoading ? (
              <GhostLoader height="20px" width="100px" />
            ) : (
              <>
                <AudienceExportStatus
                  isInHouseExport={isInHouseExport}
                  latestExportHistory={latestExportHistory}
                  inHouseModelingStatus={inHouseModelingStatus}
                  audience={x}
                  setCurrentAudience={setCurrentAudience}
                  currentAudience={currentAudience}
                />{' '}
                <IconButton
                  onClick={() => {
                    setCurrentAudienceHistory(audienceExportHistory);
                    setCurrentAudience(x || {});
                    setOpenExportHistoryDialog(true);
                  }}
                >
                  <HistoryIcon
                    style={{ fontSize: '20px', cursor: 'pointer' }}
                  />
                </IconButton>
              </>
            )}
          </Styled.AudienceStatus>
        </td>

        <td>
          <Styled.ModeledSize>
            {exportHistoryLoading ? (
              <GhostLoader height="20px" width="120px" />
            ) : (
              <>
                <div className={classes.totalSize}>{audinceSize}</div>
                <div style={{ display: 'flex' }}>
                  <div className={classes.audienceSizeStatus}>
                    {audienceExportLabel}
                  </div>
                  <div>
                    <InfoIcon
                      aria-describedby="est-audience-size"
                      className={classes.infoIcon}
                      style={{ fontSize: '20px', cursor: 'pointer' }}
                      onClick={e => {
                        setCurrentAudience(x || {});
                        setAnchorEl(e.currentTarget);
                      }}
                    />
                    {anchorEl && currentAudience?.id === x.id && (
                      <Popover
                        id="est-audience-size"
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={() => setAnchorEl(null)}
                        className={classes.popover}
                        anchorOrigin={{
                          vertical: 'center',
                          horizontal: 'right',
                        }}
                      >
                        <AudienceEstSizePopup
                          audience={x}
                          exportHistory={latestExportHistory}
                        />
                      </Popover>
                    )}
                  </div>
                </div>
              </>
            )}
          </Styled.ModeledSize>
        </td>
        <td>
          <Styled.LastModified>
            {x.updatedAt !== undefined && x.updatedAt !== 0 && (
              <>{new Date(Number(x.updatedAt)).toLocaleDateString('en-US')}</>
            )}
          </Styled.LastModified>
        </td>
      </>
    );
  });

  return (
    <>
      <ExportHistroryDialog
        isOpen={openExportHistoryDialog}
        setOpenDialog={setOpenExportHistoryDialog}
        data={currentAudienceHistory}
        normalAudience={currentAudience}
      />
      {loading === false && formattedRows.length === 0 ? (
        <NoAudiences isOnlyGroupSelected={isOnlyGroupSelected} />
      ) : (
        <div style={{ padding: '24px 32px', background: '#F0EFF1' }}>
          <DataTable
            loading={loading}
            columns={columns}
            rows={formattedRows || []}
            showRowsPerPageDropdown
            customRowsPerPageOptions={[25, 50, 100]}
            defaultRowsPerPage={25}
            onPaginationClick={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            onSortChange={handleOnSortChange}
            totalRows={count}
          />
        </div>
      )}
    </>
  );
};

const NoAudiences = ({ isOnlyGroupSelected = false }) => {
  const classes = useStyles();

  return (
    <Box className={classes.noAudiences}>
      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
      >
        <Grid item>
          <Users size={26} />
        </Grid>
        <Grid item>
          <Typography className={classes.noAudience}>
            {isOnlyGroupSelected ? (
              <>{GROUP_DONE_NOT_HAVE_AUDIENCE}</>
            ) : (
              <>{GROUP_DONE_NOT_HAVE_AUDIENCE_WITH_FILTERS}</>
            )}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            component='h4'
            variant='caption'
            className={classes.noAudienceSubText}
          >
            {isOnlyGroupSelected ? (
              <>{CREATE_AUDIENCE_BY_CLICKING}</>
            ) : (
              <>{GETTING_AUDIENCE_BY_UPATING_FILTERS}</>
            )}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

const NoCurrentGroup = () => {
  const classes = useStyles();

  return (
    <Box className={classes.noAudiences}>
      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
      >
        <Grid item>
          <GroupIcon />
        </Grid>
        <Grid item>
          <Typography component='h3' variant='h6'>
            Create or select a group
          </Typography>
        </Grid>
        <Grid item>
          <Typography component='h4' variant='caption'>
            Start by clicking &quot;Create Group&quot;.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

const LoadingAudiences = () => {
  const classes = useStyles();

  return (
    <Box className={classes.noAudiences}>
      <CircularProgress color='primary' size={40} />
    </Box>
  );
};

export const AudienceExportStatus = (props: any) => {
  const {
    latestExportHistory = null,
    inHouseModelingStatus,
    isInHouseExport = false,
    audience = null,
    setCurrentAudience,
    currentAudience,
  } = props || {};

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const status =
    latestExportHistory?.export_status || ENUM_AUDIENCE_EXPORT_STATUS.NOT_SENT;

  const { iconColor, tootipText } = getAudienceExportStatus(status);
  const isErrorStatus = status === ENUM_AUDIENCE_EXPORT_STATUS.ERROR;

  const handleErrorIconClick = event => {
    setCurrentAudience(audience || {});
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      {iconColor ? (
        <span
          title={tootipText}
          className={classes.audienceStatus}
          style={{
            color: isErrorStatus ? 'red' : '',
          }}
        >
          <CircleIcon style={{ fontSize: '10px', color: iconColor }} />
          {status || ENUM_AUDIENCE_EXPORT_STATUS.NOT_SENT}
          {isErrorStatus && (
              <ErrorIcon
                onClick={handleErrorIconClick}
                size="small"
                style={{ cursor: 'pointer' }}
              />
            )}
        </span>
      ) : null}

      {anchorEl && currentAudience?.id === audience?.id && (
        <Popover
          id="export-failure-log"
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorEl={anchorEl}
          className={classes.popover}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
        >
          <ExportFailureLogPopup exportItem={latestExportHistory} />
        </Popover>
      )}
    </>
  );
};

const getPlatformTypes = (platformTypes = []) => {
  if (platformTypes.length === 0) {
    return '-';
  }

  const allPlatforms = [];
  for (const platformType of platformTypes) {
    let platform;
    switch (platformType) {
      case PLATFORMS_KEYS.TRANSUNION_KEY:
        platform = PLATFORMS_LABLES.TRANSUNION;
        break;
      case PLATFORMS_KEYS.KLOVER_IDS_KEY:
        platform = PLATFORMS_LABLES.KLOVER_IDS;
        break;
      case PLATFORMS_KEYS.TTD_KEY:
        platform = PLATFORMS_LABLES.TTD;
        break;
      case PLATFORMS_KEYS.TRANSUNION_KEY:
        platform = PLATFORMS_LABLES.TRANSUNION;
        break;
      case PLATFORMS_KEYS.LIVERAMP_KEY:
        platform = PLATFORMS_LABLES.LIVERAMP;
        break;
      case PLATFORMS_KEYS.OPENX_KEY:
        platform = PLATFORMS_LABLES.OPENX;
        break;
      case PLATFORMS_KEYS.WPP_KEY:
        platform = PLATFORMS_LABLES.WPP;
        break;
      case PLATFORMS_KEYS.DENTSU_KEY:
        platform = PLATFORMS_LABLES.DENTSU;
        break;
      case PLATFORMS_KEYS.PUBMATIC_KEY:
        platform = PLATFORMS_LABLES.PUBMATIC;
        break;
      case PLATFORMS_KEYS.EXPERIAN_KEY:
        platform = PLATFORMS_LABLES.EXPERIAN;
        break;
      case PLATFORMS_KEYS.META_KEY:
        platform = PLATFORMS_LABLES.META;
        break;
      case PLATFORMS_KEYS.X_KEY:
        platform = PLATFORMS_LABLES.X;
        break;
      case PLATFORMS_KEYS.MAGNITE_KEY:
        platform = PLATFORMS_LABLES.MAGNITE;
        break;
      case PLATFORMS_KEYS.YAHOO_DSP_KEY:
        platform = PLATFORMS_LABLES.YAHOO_DSP;
        break;
      case PLATFORMS_KEYS.TIKTOK_KEY:
        platform = PLATFORMS_LABLES.TIKTOK;
        break;
      case PLATFORMS_KEYS.REDDIT_KEY:
        platform = PLATFORMS_LABLES.REDDIT;
        break;
      case PLATFORMS_KEYS.AMAZON_KEY:
        platform = PLATFORMS_LABLES.AMAZON;
        break;
      case PLATFORMS_KEYS.APPSFLYER_KEY:
        platform = PLATFORMS_LABLES.APPSFLYER;
        break;
      case PLATFORMS_KEYS.NEXXEN_KEY:
        platform = PLATFORMS_LABLES.NEXXEN;
        break;
      case PLATFORMS_KEYS.VIANT_KEY:
        platform = PLATFORMS_LABLES.VIANT;
        break;
      default:
        platform = '-';
        break;
    }
    allPlatforms.push(platform);
  }
  return allPlatforms;
};

const AudienceTypeLabelDisplay = ({ platformIds = [] }) => {
  const classes = useStyles();
  const firstPlacement = platformIds?.length > 0 ? platformIds[0] : null;
  const placementCount = platformIds?.length - 1;

  let restPlacements;
  if (placementCount > 0) {
    const restPlacementIds = platformIds.slice(1, platformIds.length) || [];
    restPlacements = restPlacementIds.map(x => <div key={x}>{x}</div>);
  }

  if (platformIds.length === 0) {
    return '-';
  }

  return (
    <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
      {`${firstPlacement} `}
      {placementCount > 0 && (
        <BootstrapTooltip title={restPlacements}>
          <span className={classes.typeText}>{`+${placementCount}`}</span>
        </BootstrapTooltip>
      )}
    </div>
  );
};

export default AudienceManager;
